import { useSelector } from "react-redux";

/**
 * Hook para obtener el cliente actualmente autenticado
 *
 * @returns {Object} Datos del cliente logueado
 * @returns {Object} return.cliente - Objeto completo del cliente
 * @returns {string} return.rut - RUT del cliente
 * @returns {string} return.nombre - Nombre del cliente
 * @returns {boolean} return.isLoading - true si no hay cliente cargado
 *
 * @example
 * // Uso básico
 * const { cliente, rut, nombre } = useClienteActual();
 *
 * @example
 * // Uso en RTK Query
 * const { rut } = useClienteActual();
 * const { data: tareas } = useObtenerTareasClienteQuery(rut);
 *
 * @example
 * // Uso con loading state
 * const { cliente, isLoading } = useClienteActual();
 * if (isLoading) return <Skeleton />;
 */
export const useClienteActual = () => {
  const cliente = useSelector((state) => state.auth.user?.cliente);

  return {
    cliente,
    rut: cliente?.rut,
    nombre: cliente?.nombre,
    isLoading: !cliente,
  };
};
